import type { ComputedRef, InjectionKey } from 'vue';

import { StepperOrientation, StepperTheme } from './Stepper.types';

export interface StepperProvideInject {
  registerStep: (nested: boolean) => void;
  orientation: StepperOrientation;
  stepCount: ComputedRef<number>;
  theme: StepperTheme;
  showResponsiveNav: ComputedRef<boolean>;
}

export const STEPPER_INJECTION_KEY = Symbol('STEPPER_INJECTION_KEY') as InjectionKey<StepperProvideInject>;
